import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { searchImap } from 'wisestep-api';
export interface ImapSearchResponse {
  id: string;
  from: string;
  fromName: null;
  to: string[];
  cc: string[] | null;
  bcc: string[] | null;
  subject: string;
  body: string;
  createdOn: string;
  attachments: attachmentType[] | [];
}

export interface attachmentType {
  id: string | null;
  uuid: string;
  messageId: string | null;
  fileName: string | null;
  fileSize: number;
  fileLocation: string | null;
  attachmentIndex: number;
}

const useSearch = (searchQuery: string, email: string) => {
  const [searchResponse, setSearchResponse] = useState<ImapSearchResponse[]>([]);
  useEffect(() => {
    const hitSearch = async () => {
      if (!isEmpty(searchQuery)) {
        const searchResponse = await searchImap(searchQuery, email);
        setSearchResponse(searchResponse.data);
      }
    };
    hitSearch();
  }, [email, searchQuery]);
  return searchResponse;
};
export default useSearch;
